export const settings = {
    gateway_api: {
        base_url: "/api"
    },
    default_locale: "no",
    languages: [
        {
            locale: "en",
            name: "English"
        },
        {
            locale: "no",
            name: "Norsk"
        }
    ]
}
